import moment from 'moment';

export const console_log = (param1, param2) => {
    if (param2) {
        console.log(param1, param2);
    } else {
        console.log(param1);
    }
};

export const parseQueryString = (url) => {
    var urlParams = {};
    url.replace(
        new RegExp("([^?=&]+)(=([^&]*))?", "g"),
        function($0, $1, $2, $3) {
            urlParams[$1] = $3;
        }
    );

    return urlParams;
};

export const jsUcfirst = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const formatDate = (date, format) => {
    return moment(date).format(format);
};

export const isBetween = (date, start, end) => {
    return moment(date).isBetween(start, end);
};

export const fromNow = (dateTime) => {
    return moment(dateTime).fromNow();
};

export const getSubdomain = () => {
    const hostname = window.location.hostname;
    const parts = hostname.split('.');
    return parts[0];
}
export const getUid = () => {
    const href = window.location.href;
    let uidIndex=href.indexOf('uid');
    let uid;
    if(uidIndex>=0){
        uid=href.substring(uidIndex+4,href.length)
        return uid;
    }else{
        return null
    }
}
const parseQs = (s) => {
    if(!s) return {};
    s = s.split('?')[1];
    if(!items) return {};
    const items = s.split('&');
    const q = items.reduce((agg, x) => {
        let key = x.split('=')[0].trim();
        let value = x.split('=')[1];
        return {...agg, [key]: value}
    }, {})
    return q;
}
const hashToQuery = () => {
    const d = window.location.hash.slice(1);
    if (d[0] === "/") return d.slice(1);
    else return d;
  };
export const getParameters = (params) => {
    const queryStrings = parseQs(window.location.search);
    const hashQueryStrings = parseQs(hashToQuery());
    
    const d = queryStrings[params] || hashQueryStrings[params];
    console_log(d);
    return {
     exist: d && d.length > 0,
     value: d
    };
};



// WEBPACK FOOTER //
// ./src/utils/helper.js